

export default class {
    constructor($el, windowPal) {
        this.$ = $el;
        this.windowPal = windowPal;
        this.$left = $el.find('.-left');
        this.$right = $el.find('.-right');
        this.$window = $el.find('.-window');
        this.$strip = this.$window.find('.-strip');
        this.$cells = this.$strip.find('.-cell');
        this.$firstCell = $(this.$cells[0]);
        this.data = $el.data('slideshow');
        this.cols = null;
        this.enabled = false;
        this.n = this.$cells.length;
        this.cellWidth = (100 / this.n)  + '%';
        if (this.data) {
            this.enabled = true;
            this.$left.click(()=>{
                this.click(0 - this.cols);
            });
            this.$right.click(()=>{
                this.click(this.cols);
            });
            let debugCols = [];
            if (this.data === 'mobile-only') {
                this.data = {
                    breakpoints: [
                        {
                            minWidth: 0,
                            cols: 1
                        }
                    ]
                };
                this.$cells.each((i, el)=>{
                    // console.log(el, this.cellWidth);
                    $(el).css('width', this.cellWidth);
                });
            } else if (this.data === 'never-slideshow') {
                this.enabled = false;
            } else {
                windowPal.resize(()=>{
                    this.updateLayout();
                });
                this.$cells.each((i, el)=>{
                    // console.log(el, this.cellWidth);
                    debugCols.push(el);
                    $(el).css('width', this.cellWidth);
                });
                console.log('cells', this.n, 'width', this.cellWidth, debugCols);
            }
            if (this.enabled) {
                this.updateLayout();
            }
        }
    }
    updateLayout() {
        let windowWidth = this.windowPal.$.width(),
            breakPoint;

        this.data.breakpoints.forEach((bPoint, i)=>{
            if ( ! breakPoint && windowWidth > bPoint.minWidth) {
                breakPoint = bPoint;
            }
        });
        if (breakPoint) {
            if (this.cols !== breakPoint.cols) {
                this.cols = breakPoint.cols;
                this.updateDom();
            }
        } else {
            console.error('No breakpoint for '+windowWidth);
        }
    }
    updateDom() {
        let width = this.n * 100 / this.cols;
        // console.log(this.cols, width, typeof width);
        this.$strip.css('width', width + '%');
    }
    click(inc) {
        let currentPosPx = this.$window.scrollLeft(),
            cellWidth = this.$firstCell.outerWidth(true),
            currentPos = Math.round(currentPosPx / cellWidth);
        // console.log(currentPosPx, cellWidth, currentPos);
        this.moveTo((currentPos + inc) * cellWidth);
    }
    moveTo(px) {
        // console.log(px);
        this.$window.animate({scrollLeft:px}, 200, 'swing', function() {
            // console.log('done');
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/lib/Slideshow.js